import { selectBusinessDetails } from '../selectors/selectBusinessDetails';
import {
  InsuredType,
  PropertyType,
  updateInsuredType,
  updatePropertyType,
} from '../slices/businessDetails';
import { clearCoverDetails } from '../slices/coverDetails';
import { clearCovers } from '../slices/selectCover';
import { createAppAsyncThunk } from '../utils/redux-helpers';

export const updateInsuredTypeAction = createAppAsyncThunk(
  'state-action/updateInsuredType',
  async (insuredType: InsuredType | undefined, { getState, dispatch }) => {
    if (selectBusinessDetails(getState()).insuredType !== insuredType) {
      dispatch(updateInsuredType(insuredType));
      dispatch(clearCovers());
      dispatch(clearCoverDetails());
    }
  }
);

export const updatePropertyTypeAction = createAppAsyncThunk(
  'state-action/updateInsuredType',
  async (propertyType: PropertyType | undefined, { getState, dispatch }) => {
    if (selectBusinessDetails(getState()).propertyType !== propertyType) {
      dispatch(updatePropertyType(propertyType));
      dispatch(clearCovers());
      dispatch(clearCoverDetails());
    }
  }
);
